import { IDropdownOption } from '@fluentui/react'
import { Protocol_Type, Wizard_Mode } from '../../shared/enums'
import { IChoiceField, IField } from '../../shared/interfaces'
import {
    ProtocolWizardReduxState, ProtocolWizardActionTypes,
    SET_WIZARD_INITIAL_STATE, SET_WIZARD_DOCUMENT_FILE, UPDATE_WIZARD_PROTOCOL_STATE, SET_WIZARD_PROTOCOL, 
    ADD_WIZARD_ATTACHMENT, SET_WIZARD_PROTOCOL_TOUCHED, UPDATE_WIZARD_ATTACHMENT, SET_WIZARD_ATTACHMENTS,
    SET_WIZARD_SELECTED_PRINTER_NAME, SET_WIZARD_DOCUMENT_SCANNER_LOADER, SET_WIZARD_ATTACHMENT_SCANNER_LOADER
} from './types'

const initialScannerFields: IField[] = [
    {
        displayName: "Scanner disponibili",
        internalName: "sourceName",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField,
    {
        displayName: "Fronte/Retro",
        internalName: "duplex",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField,
    {
        displayName: "Modalit\u00e0 colore",
        internalName: "pixelType",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField,
    {
        displayName: "Risoluzione (dpi)",
        internalName: "resolution",
        controlType: "dropdown",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: null,
        valid: false,
        touched: false,
        multi: false,
        options: [] as IDropdownOption[]
    } as IChoiceField

];

const initialState: ProtocolWizardReduxState = {
    wizardMode: Wizard_Mode.Create,
    protocol: {
        tipoProtocollo: Protocol_Type.Undefined,
        fields: [],
        attachments: [],
        visibilita: []
    },
    docInFields: undefined,
    docOutFields: undefined,
    docInternalFields: undefined,
    pageScaledWidth: 0,
    pageScaledHeight: 0,
    valid: true,
    touched: false,
    selectedPrinterName: undefined,
    documentFileSource: "locale",
    attachmentFileSource: "locale",
    documentScannerFields: [...initialScannerFields],
    attachmentScannerFields: [...initialScannerFields],
    documentScannerLoader: false,
    attachmentScannerLoader: false
}

export function protocolWizardReducer(state = initialState, action: ProtocolWizardActionTypes): ProtocolWizardReduxState {
    switch (action.type) {
        case SET_WIZARD_INITIAL_STATE: {
            return {
                ...initialState,
                wizardMode: action.wizardMode
            }
        }
        case SET_WIZARD_DOCUMENT_FILE: {
            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    documentFile: action.documentFile
                }
            }
        }
        case SET_WIZARD_ATTACHMENTS: {
            let newAttachments = action.attachmentsFile ? [...action.attachmentsFile] : []

            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    attachments: [...newAttachments]
                }
            }
        }
        case ADD_WIZARD_ATTACHMENT: {
            let newAttachments = state.protocol?.attachments ? [...state.protocol?.attachments] : []
            newAttachments.push(action.attachmentFile);

            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    attachments: [...newAttachments]
                }
            }
        }
        case UPDATE_WIZARD_ATTACHMENT: {
            let newAttachments = state.protocol?.attachments ? [...state.protocol?.attachments] : []
            let index = newAttachments.findIndex(el => el.id === action.attachmentFile.id)
            if (index != -1)
                newAttachments[index] = { ...action.attachmentFile };

            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    attachments: [...newAttachments]
                }
            }
        }
        case SET_WIZARD_PROTOCOL: {
            return {
                ...state,
                protocol: {
                    ...state.protocol,
                    ...action.protocol
                }
            }
        }
        case SET_WIZARD_DOCUMENT_SCANNER_LOADER: {
            return {
                ...state,
                documentScannerLoader: action.documentScannerLoader
            }
        }
        case SET_WIZARD_ATTACHMENT_SCANNER_LOADER: {
            return {
                ...state,
                attachmentScannerLoader: action.attachmentScannerLoader
            }
        }
        case SET_WIZARD_SELECTED_PRINTER_NAME: {
            return {
                ...state,
                selectedPrinterName: action.selectedPrinterName
            }
        }
        case UPDATE_WIZARD_PROTOCOL_STATE: {
            return {
                ...state,
                ...action.payload
            }
        }
        case SET_WIZARD_PROTOCOL_TOUCHED: {
            return {
                ...state,
                touched: true
            }
        }

        default:
            return state
    }
}